export const groupedByOrigin = {
  Austria: ["Germany", "Poland"],
  Belgium: ["Germany", "Poland"],
  Bulgaria: ["Germany"],
  "Czech Republic": ["Poland"],
  Denmark: ["Germany"],
  France: ["Poland", "Germany"],
  Germany: ["Poland", "France"],
  Greece: ["Germany", "Poland"],
  Hungary: ["France", "Germany", "Poland"],
  India: ["Nepal"],
  Italy: ["France", "Germany", "Poland"],
  Netherlands: ["Germany", "Poland"],
  Poland: ["France", "Germany"],
  Rwanda: ["Kenya"],
  Slovakia: ["France", "Germany", "Poland"],
  Slovenia: ["Poland"],
  Spain: ["Poland"],
  Switzerland: ["Germany", "Poland"],
};
